import "core-js/modules/es.array.find-index.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: "Category",
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    this.scrollIntoActiveCategory();
  },
  watch: {
    value: function value(activeCategory) {
      var activeIndex = this.categories.findIndex(function (element) {
        return element.id === activeCategory.id;
      });
      this.scrollIntoActiveCategory(activeIndex);
    }
  },
  methods: {
    onClickCategory: function onClickCategory(item) {
      window.scrollTo({
        top: 0,
        behavior: 'auto'
      });
      this.$emit('input', item);
    },
    scrollIntoActiveCategory: function scrollIntoActiveCategory() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.$refs && this.$refs.linksRef && this.$refs.linksRef[index]) {
        try {
          this.$refs.linksRef[index].scrollIntoView({
            behavior: "auto",
            block: "center",
            inline: "center"
          });
        } catch (e) {
          console.log(e);
        }
      }
    }
  },
  props: {
    categories: {
      type: Array,
      required: true
    },
    value: {
      type: Object
    }
  }
};